import React, {
  ChangeEvent,
  Fragment,
  useEffect,
  useMemo,
  useState
} from 'react';
import {
  Box,
  Button,
  Card,
  CardHeader,
  Checkbox,
  Container,
  FormControl,
  Grid,
  InputAdornment,
  InputLabel,
  ListSubheader,
  MenuItem,
  Select,
  Table,
  TableBody,
  TableContainer,
  TableHead,
  TablePagination,
  TableRow,
  TextField,
  Tooltip,
  Typography
} from '@mui/material';
import PageTitleWrapper from 'src/components/PageTitleWrapper';
import FilterListIcon from '@mui/icons-material/FilterList';
import SearchIcon from '@mui/icons-material/Search';
import { useForm } from 'react-hook-form';
import AddTwoToneIcon from '@mui/icons-material/AddTwoTone';
import styled from '@emotion/styled';
import { withStyles } from '@mui/styles';
import moment from 'moment';
import { TableHeaderCell } from 'src/components/TableHeaderCell';
import { TableColumnCell } from 'src/components/TableColumnCell';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import {
  createTeam,
  createTeamResource,
  deleteTeamRole,
  filterTeams,
  getTeams,
  resourceDeAllocation,
  searchTeams
} from 'src/services/projectService';
import {
  getAllBillingRoles,
  getAllEmployees,
  getAllSkills,
  getAllTracks
} from 'src/services/employeeService';
import Multiselect from 'multiselect-react-dropdown';
import CloseIcon from '@mui/icons-material/Close';
import DoneIcon from '@mui/icons-material/Done';
import EditIcon from '@mui/icons-material/Edit';
import DeleteForeverIcon from '@mui/icons-material/DeleteForever';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import ExpandLessIcon from '@mui/icons-material/ExpandLess';
import AllocateResourcesModal from './AllocateResourcesModal';
import SnackBar from 'src/components/SnackBar/SnackBar';
import { downloadProjectsTeamsReport, getSingleProject } from 'src/services/projectDetailService';
import UpdateModal from './UpdateModal';
import ConfirmationModal from 'src/content/common/confirmationModal/ConfirmationModal';
import { useAppSelector } from 'src/hooks/hooks';
import { AppActions } from 'src/store/AppReducer';
import { useDispatch, useSelector } from 'react-redux';
import { DatePicker } from '@mui/lab';
import 'src/content/projectDetails/ProjectDetails.css';
import CreateForm from './CreateForm';
import GetAppIcon from '@mui/icons-material/GetApp';
import { RootStateType } from 'src/store/RootReducer';
import fileDownload from 'js-file-download';

interface Filters {
  customerName: string;
  code: string;
  country: string;
  industry: string;
}

const applyFilters = (employees: any[], filters: Filters): any[] => {
  return employees?.filter((employeeStatus) => {
    let matches = true;
    // if (filters.status && employeeStatus.status !== filters.status) {
    //   matches = false;
    // }
    return matches;
  });
};

const TEAM_LINE_HEIGHT = '42px';
const TEAM_LINE_BORDER = '1px solid rgba(224, 224, 224, 1)';
const EXPANDED_HEADER_BG = '#E6E9FF';
const EXPANDED_CHILD_BG = '#F7F8FC';

const teamLineStyle = (
  bordered: boolean,
  extra?: React.CSSProperties
): React.CSSProperties => ({
  display: 'flex',
  alignItems: 'center',
  height: TEAM_LINE_HEIGHT,
  fontSize: '11px',
  boxSizing: 'border-box',
  width: '100%',
  overflow: 'hidden',
  whiteSpace: 'nowrap',
  borderBottom: bordered ? TEAM_LINE_BORDER : 'none',
  padding: '0 16px',
  ...extra
});

const TeamLines = ({
  count,
  renderContent,
  lineStyle,
  expanded
}: {
  count: number;
  renderContent: (index: number) => React.ReactNode;
  lineStyle?: React.CSSProperties;
  expanded?: boolean;
}) => (
  <>
    {Array.from({ length: count }).map((_, index) => (
      <div
        key={index}
        style={teamLineStyle(index < count - 1, {
          background: expanded
            ? index === 0
              ? EXPANDED_HEADER_BG
              : EXPANDED_CHILD_BG
            : 'transparent',
          ...lineStyle
        })}
      >
        <span
          style={{
            display: 'block',
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            whiteSpace: 'nowrap',
            minWidth: 0,
            width: '100%'
          }}
        >
          {renderContent(index)}
        </span>
      </div>
    ))}
  </>
);

const applyPagination = (
  employees: any[],
  page: number,
  limit: number
): any[] => {
  return employees.slice(page * limit, page * limit + limit);
};

const TeamsTable = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { projectCode } = useParams();
  const appUser = useSelector((state: RootStateType) => state.appReducer.user);

  //set edit and view page
  const useQuery = () => {
    return new URLSearchParams(useLocation().search);
  }
  const query = useQuery();
  const [visibility, setVisibility] = useState('');
  const [isEdit, setIsEdit] = useState(false);

  useEffect(() => {
    setVisibility(query.get('view'));
  }, [query]);

  useEffect(() => {
    if(visibility === 'true') {
      setIsEdit(true);
    }else{
      setIsEdit(false);
    }
  },[visibility]);

  let initialProjectFilterValues = {
    role: null,
    resourceType: null,
    roleType: null,
    status: null,
    startDate: null,
    endDate: null
  } as any;

  const [filters] = useState<Filters>({
    customerName: null,
    code: null,
    country: null,
    industry: null
  });

  const [projectDetails, setProjectDetails] = useState<any>({});

  const getSingleProjectData = () => {
    getSingleProject(projectCode).then((res) => {
      const data = res.data;
      setProjectDetails(data);
    });
  };

  const { register, handleSubmit, reset, getValues, setValue } = useForm<any>();

  const [isDisabled, setIsDisable] = useState(true);
  const [toggleFilter, setToggleFilter] = useState(false);
  const [teamsFilter, setTeamsFilter] = useState<any>({});
  const [startError, setStartDateError] = useState('');
  const [endDateError, setEndDateError] = useState('');
  const [isDisabledClearBtn, setIsDisabledClearBtn] = useState<boolean>(true);

  const [page, setPage] = useState<number>(0);
  const [limit, setLimit] = useState<number>(10);

  const { isLoading } = useAppSelector((state) => state.appReducer);

  var initalList: any[] = [];

  const [teams, setTeams] = useState<any>(initalList);
  const [teamsData, setTeamsData] = useState<any>([]);

  const filteredTeams = applyFilters(teams, filters);

  const paginatedTeams = applyPagination(filteredTeams, page, limit);

  const onSubmit = (data: any) => {
    filterTeamMembers();
  };


  const filterTeamMembers = () => {
    const allData = teamsFilter;
    if (allData.startDate && !allData.endDate) {
      setEndDateError('To Date Required');
    } else if (allData.endDate && !allData.startDate) {
      setStartDateError('From Date Required');
    } else {
      setStartDateError('');
      setEndDateError('');
      allData.startDate = allData?.startDate
        ? moment(allData?.startDate).format('YYYY-MM-DD')
        : null;
      allData.endDate = allData?.endDate
        ? moment(allData?.endDate).format('YYYY-MM-DD')
        : null;

      const body = {
        projectCode: projectDetails?.key,
        ...allData
      };
      filterTeams(body).then((res) => {
        setPage(0);
        const allTeams = res.data || [];
        const sortedData = allTeams.sort((a, b) =>
          b.code.localeCompare(a.code)
        );

        const allSorted = sortedData.map((ele, index) => {
          const newData = ele.resourceAllocations.sort((a, b) => {
            var dateA = moment.utc(a.createdOn || new Date()).format();
            var dateB = moment.utc(b.createdOn || new Date()).format();
            return Date.parse(dateB) - Date.parse(dateA);
          });
          return {
            ...ele,
            resourceAllocations: newData
          };
        });

        setTeams((allSorted as any[]) || []);
      });
    }
  }

  const resetFilterResult = () => {
    setIsDisable(true);
    setStartDateError('');
    setEndDateError('');
    reset();
    setTeamsFilter({});
    getTeamsData(projectDetails?.key);
    setIsDisabledClearBtn(true);
  };

  const [searchKeywords, setSearchKeywords] = useState('');

  //when user started to type the name in the text field
  const nameChange = (event) => {
    setSearchKeywords(event.target.value);
  };

  const filterByName = (array, keyword) => {
    const result = [];
    for (let i = 0; i < array.length; i++) {
        const item = array[i];
        const allocations = [];
        for (let j = 0; j < item.resourceAllocations.length; j++) {
            if (item.resourceAllocations[j].name.toLowerCase().includes(keyword.toLowerCase())) {
                allocations.push(item.resourceAllocations[j]);
            }
        }
        allocations.length > 0 && result.push({...item, resourceAllocations: allocations});
    }
    return result;
};

  const searchGroupsAll = async (keyword: string) => {
    dispatch(AppActions.showLoader());

    //set frontend search
    const filterResources = filterByName(teamsData, keyword);

    const allSorted = filterResources.map((ele, index) => {
      const newData = ele.resourceAllocations.sort((a, b) => {
        var dateA = moment.utc(a.createdOn || new Date()).format();
        var dateB = moment.utc(b.createdOn || new Date()).format();
        return Date.parse(dateB) - Date.parse(dateA);
      });
      return {
        ...ele,
        resourceAllocations: newData
      };
    });

    setTeams(allSorted || []);
    dispatch(AppActions.hideLoader());
  };

  useEffect(() => {
    if (searchKeywords.length > 0 ) {
      setPage(0);
      searchGroupsAll(searchKeywords);
    }
    else {
      getTeamsData(projectDetails?.key);
    }
  }, [searchKeywords]);


  const CardHeaderWrapper = styled(CardHeader)(
    () => `
        .MuiCardHeader-action{
          width: 100%
        }
      `
  );

  const CustomTableRow = withStyles({
    root: {
      background: '#E6E9FF !important',
      height: '3.5rem'
    }
  })(TableRow);

  const handlePageChange = (event: any, newPage: number): void => {
    setPage(newPage);
  };

  const handleLimitChange = (event: ChangeEvent<HTMLInputElement>): void => {
    setLimit(parseInt(event.target.value));
  };

  const getTeamsData = (code) => {
    dispatch(AppActions.showLoader());

    if (code)
      getTeams(code).then((res) => {
        const allTeams = res.data || [];
        const sortedData = allTeams.sort((a, b) =>
          b.code.localeCompare(a.code)
        );

        const allSorted = sortedData.map((ele, index) => {
          const newData = ele.resourceAllocations.sort((a, b) => {
            var dateA = moment.utc(a.createdOn || new Date()).format();
            var dateB = moment.utc(b.createdOn || new Date()).format();
            return Date.parse(dateB) - Date.parse(dateA);
          });
          return {
            ...ele,
            resourceAllocations: newData
          };
        });

        setTeams(allSorted);
        setTeamsData(allSorted);
        dispatch(AppActions.hideLoader());
      });
  };

  const padLeft = (nr?: any, n?: any, str?: any) => {
    return Array(n - String(nr).length + 1).join(str || '0') + nr;
  };

  useEffect(() => {
    if (projectCode) {
      getSingleProjectData();
    }
  }, [projectCode]);

  useEffect(() => {
    if (projectDetails?.key) {
      getTeamsData(projectDetails?.key);
    }
  }, [projectDetails]);

  const [createRoleObj, setCreateRoleObj] = useState<any>({});
  const [allocateResource, setAllocateResource] = useState<any>({});
  const [createRoleObjErrors, setCreateRoleObjErrors] = useState<any>({});
  const [clickedCreate, setClickedCreate] = useState(false);

  const [checkedRoles, setCheckedRoles] = useState<any>([]);
  const [checkedRolesData, setCheckedRolesData] = useState<any>([]);
  useEffect(() => {
    if (checkedRoles.length > 0) {
      const selectedRoles = teams.filter((team) =>
        checkedRoles.includes(team.code)
      );

      setCheckedRolesData(selectedRoles);
    }
  }, [checkedRoles, teams]);

  const [snackBarOpen, setSnackBarOpen] = useState(false);
  const [snackbarSeverity, setSnackbarSeverity] = useState('');
  const [snackBarMessage, setSnackBarMessage] = useState('');

  useEffect(() => {
    setDefaultValues();
  }, [teams, projectCode, projectDetails]);

  const [billingRoles, setBillingRoles] = useState<any>([]);

  const [tracks, setTracks] = useState<any>([]);
  const [allSkills, setAllSkills] = useState<any>([]);
  const [allEmployees, setAllEmployees] = useState<any>([]);

  const getAllListData = () => {
    getAllEmployees().then((res) => setAllEmployees(res.data));
    getAllBillingRoles().then((res) => setBillingRoles(res.data));
    getAllTracks().then((res) => setTracks(res.data));
    getAllSkills().then((res) => {
      setAllSkills(
        res?.data.map((ele) => {
          return { name: ele };
        })
      );
    });
  };

  useEffect(() => {
    getAllListData();
  }, []);

  const onSelect = (selectedList, selectedItem) => {
    setCreateRoleObj((prev) => ({
      ...prev,
      skills: selectedList.map((sel) => sel.name)
    }));
  };

  const onRemove = (selectedList, selectedItem) => {
    setCreateRoleObj((prev) => ({
      ...prev,
      skills: selectedList.map((sel) => sel.name)
    }));
  };
  const [open, setOpen] = useState(false);
  const [openUpdate, setOpenUpdate] = useState(false);
  const [updateData, setUpdateData] = useState<any>({});
  const [isOpenAdded, setIsOpenAdded] = useState(false);

  const toggle = () => {
    if (!open && checkedRoles.length > 0) {
      setOpen(true);
    } else {
      setOpen(false);
    }
  };

  const toggleUpdate = () => {
    setOpenUpdate(!openUpdate);
  };

  const toggleAdded = () => {
    setIsOpenAdded(!isOpenAdded);
  }

  const [expandedCodes, setExpandedCodes] = useState<string[]>([]);

  const dropDown = (code) => {
    setExpandedCodes((current) =>
      current.includes(code)
        ? current.filter((item) => item !== code)
        : [...current, code]
    );
  };

  const [openConfirmation, setOpenConfirmation] = useState(false);

  const toggleConfirmation = () => {
    setOpenConfirmation(!openConfirmation);
  };

  const [openConfirmationDelete, setOpenConfirmationDelete] = useState(false);
  const [deleteRoleId, setDeleteRoleId] = useState('');
  const [openConfirmationDeleteAllocation, setOpenConfirmationDeleteAllocation] =
    useState(false);
  const [deleteAllocationId, setDeleteAllocationId] = useState('');

  const isAllocationLocked = (allocation) => {
    if (!allocation?.createdOn) {
      return false;
    }
    return moment(allocation.createdOn).isSameOrBefore(
      moment().subtract(2, 'months'),
      'day'
    );
  };

  const toggleConfirmationDelete = () => {
    setOpenConfirmationDelete(!openConfirmationDelete);
  };

  const toggleConfirmationDeleteAllocation = () => {
    setOpenConfirmationDeleteAllocation(!openConfirmationDeleteAllocation);
  };

  const deleteRole = (id) => {
    dispatch(AppActions.showLoader());

    deleteTeamRole(id)
      .then(() => {
        setSnackBarMessage('You have deleted the Project Role successfully.');
        setSnackbarSeverity('success');
        setSnackBarOpen(true);
        getTeamsData(projectDetails?.key);
        toggleConfirmationDelete();
        setIsChecked(false);
        dispatch(AppActions.hideLoader());
      })
      .catch(() => {
        setSnackBarMessage('Unable deleted the Project Role.');
        setSnackbarSeverity('error');
        setSnackBarOpen(true);
        dispatch(AppActions.hideLoader());
      });
  };

  const deleteAllocation = (id) => {
    dispatch(AppActions.showLoader());

    resourceDeAllocation(id)
      .then(() => {
        setSnackBarMessage(
          'You have deleted the resource allocation successfully.'
        );
        setSnackbarSeverity('success');
        setSnackBarOpen(true);
        getTeamsData(projectDetails?.key);
        toggleConfirmationDeleteAllocation();
        setDeleteAllocationId('');
        dispatch(AppActions.hideLoader());
      })
      .catch(() => {
        setSnackBarMessage('Unable to delete the resource allocation.');
        setSnackbarSeverity('error');
        setSnackBarOpen(true);
        dispatch(AppActions.hideLoader());
      });
  };

  const containsText = (text, searchText) =>
    text.toLowerCase().indexOf(searchText.toLowerCase()) > -1;

  const [searchText, setSearchText] = useState('');
  const [searchText2, setSearchText2] = useState('');

  const displayedOptions = useMemo(
    () =>
      billingRoles.length > 0 &&
      billingRoles?.filter((option) => containsText(option.name, searchText)),
    [searchText, billingRoles]
  );

  const displayedOptions2 = useMemo(
    () =>
      allEmployees.length > 0 &&
      allEmployees?.filter((option) => containsText(option.name, searchText2)),
    [searchText2, allEmployees]
  );

  const [isChecked, setIsChecked] = useState(false);


  //set disabled filter button
  const filterMandatoryFled = (e) => {
    if(e) {
      teamsFilter.startDate
      ? teamsFilter.endDate
        ? setIsDisable(false)
        : setIsDisable(true)
      : teamsFilter.endDate
      ? teamsFilter.startDate
        ? setIsDisable(false)
        : setIsDisable(true)
      : setIsDisable(false);
    }
  }

  const setDefaultValues = () => {
    if (projectDetails?.key) {
      setCreateRoleObj((prev) => ({
        ...prev,
        projectCode: projectDetails?.key
      }));
    }

    if (teams.length === 0) {
      setCreateRoleObj((prev) => ({
        ...prev,
        code: `${projectDetails?.key}001`
      }));
      setAllocateResource((prev) => ({
        ...prev,
        projectRoleCode: `${projectDetails?.key}001`
      }));
    } else {
      const code = teams[0]?.code;

      const splitCode = code.split(projectDetails?.key)[1];
      setCreateRoleObj((prev) => ({
        ...prev,
        code: `${projectDetails?.key}${padLeft(Number(splitCode) + 1, 3)}`
      }));
      setAllocateResource((prev) => ({
        ...prev,
        projectRoleCode: `${projectDetails?.key}${padLeft(
          Number(splitCode) + 1,
          3
        )}`
      }));
    }
  }

  const [sortResourceNameType, setSortResourceNameType] = useState('asc');

  useEffect(() => {
    if (teams?.length > 0 && sortResourceNameType === 'asc') {
      setTeams(teams.sort((a, b) => a?.resourceAllocations[0]?.name.localeCompare(b?.resourceAllocations[0]?.name)));
    } else if (teams?.length > 0 && sortResourceNameType === 'desc') {
      setTeams(teams.sort((a, b) => b?.resourceAllocations[0]?.name.localeCompare(a?.resourceAllocations[0]?.name)));
    }
  }, [sortResourceNameType]);


  const handleDownload = () => {
    dispatch(AppActions.showLoader());
    downloadProjectsTeamsReport({
      ...teamsFilter,
        projectCode: projectDetails?.key,
    })
    .then((res) => {
      if(res.status === 200) {
        fileDownload(res.data, 'teams-report.xlsx');
      }else{
        setSnackBarMessage('No data found.');
        setSnackbarSeverity('error');
        setSnackBarOpen(true);
      }
      dispatch(AppActions.hideLoader());
    })
    .catch((err) => {
      setSnackBarMessage('No data found.');
      setSnackbarSeverity('error');
      setSnackBarOpen(true);
      dispatch(AppActions.hideLoader());
    });
  }

  return (
    <Fragment>
      <Grid container direction={'row'} sx={{ py: 2, px: 3 }}>
        <Grid item>
          <Typography
            id="breadcrumbs-teams-project-details"
            onClick={() => {
              navigate('/project-details');
            }}
            style={{ cursor: 'pointer' }}
            variant="h4"
            component="h4"
          >
            {' '}
            Project Details /
          </Typography>
        </Grid>
        <Grid item>
          <Typography
            style={{ fontWeight: 'normal' }}
            variant="h4"
            component="h4"
          >
            &nbsp; {projectDetails?.name} / Teams
          </Typography>
        </Grid>
      </Grid>
      <Container maxWidth="xl">
        <Card>
          <Grid
            container
            style={{
              justifyContent: 'space-between',
              padding: '1rem'
            }}
            spacing={2}
          >
            <Grid item xs={6}>
              <TextField
                id="search-teams-nameChange"
                sx={{ width: 320, mr: 2 }}
                size="small"
                placeholder="Resource Name..."
                onChange={(e) => nameChange(e)}
                InputProps={{
                  style: { fontSize: '12px', height: '1.75rem' },
                  startAdornment: (
                    <InputAdornment position="start">
                      <SearchIcon
                        sx={{ color: '#d3d3d3' }}
                        style={{ fontSize: '15px' }}
                      />
                    </InputAdornment>
                  )
                }}
              />
              <Button
                id="btn-teams-toggleFilter"
                sx={{
                  mt: { xs: 2, md: 0 },
                  color: `${!toggleFilter && 'gray'}`
                }}
                variant="outlined"
                startIcon={<FilterListIcon />}
                onClick={() => {
                  setToggleFilter(!toggleFilter);
                  resetFilterResult();
                }}
                style={{ height: '1.75rem', fontSize: '12px' }}
              >
                Filters
              </Button>
            </Grid>
            <Grid item>
              <Button
                id="btn-toggle"
                disabled={!isChecked}
                onClick={() => toggle()}
                sx={{
                  mt: { xs: 2, md: 0 },
                  fontSize: '11px',
                  fontWeight: 'normal',
                  mr: 2
                }}
                variant="contained"
                style={{ height: '1.75rem' }}
              >
                Allocate Resource
              </Button>
              <Button
                id="btn-setClickedCreate"
                disabled={searchKeywords?.length > 0 || isChecked || !isEdit}
                onClick={() => {
                  toggleAdded();
                }}
                sx={{
                  mt: { xs: 2, md: 0 },
                  fontSize: '11px',
                  fontWeight: 'normal',
                  mr: 2
                }}
                variant="contained"
                startIcon={<AddTwoToneIcon fontSize="small" />}
                style={{ height: '1.75rem' }}
              >
                Create New Role
              </Button>
              {appUser.Roles.split(',').includes('Super User') &&
              <Button
                sx={{
                  mt: { xs: 2, md: 0 },
                  fontSize: '11px',
                  fontWeight: 'normal'
                }}
                variant="contained"
                startIcon={<GetAppIcon fontSize="small" />}
                style={{ height: '1.75rem' }}
                onClick={handleDownload}
              >
                Download Report
              </Button>
            }
            </Grid>
          </Grid>
          {/* <CardHeaderWrapper
            style={{ padding: 0 }}
            action={
              <> */}
                { toggleFilter && (
                <Grid px={2} style={{margin: 0}}>
                  <form onSubmit={handleSubmit(onSubmit)}>
                    <Grid
                      container
                      spacing={2}
                      style={{
                        paddingTop: 3,
                        paddingBottom: 2,
                        justifyContent: 'flex-start'
                      }}
                    >
                      <Grid item xs={3}>
                        <FormControl fullWidth>
                          <InputLabel
                            style={{
                              fontSize: '12px'
                            }}
                          >
                            Project Role
                          </InputLabel>
                          <Select
                            id="filter-role"
                            sx={{ mt: 1 }}
                            style={{
                              fontSize: '12px',
                              height: '2rem'
                            }}
                            fullWidth
                            size="small"
                            {...register('role')}
                            value={teamsFilter?.role}
                            onChange={(e) => {
                              setTeamsFilter((prev) => ({
                                ...prev,
                                role: e.target.value
                              }));
                              setValue('role', e.target.value);
                              filterMandatoryFled(e.target.value);
                              setIsDisabledClearBtn(false);
                            }}
                          >
                            {(billingRoles || []).map((item, i) => {
                              return (
                                <MenuItem value={item.name} key={i}>
                                  {item.name}
                                </MenuItem>
                              );
                            })}
                          </Select>
                        </FormControl>
                      </Grid>
                      <Grid item xs={3}>
                        <FormControl fullWidth>
                          <InputLabel
                            style={{
                              fontSize: '12px'
                            }}
                          >
                            Resource Type
                          </InputLabel>
                          <Select
                            id="filter-resourceType"
                            sx={{ mt: 1 }}
                            style={{
                              fontSize: '12px',
                              height: '2rem'
                            }}
                            fullWidth
                            size="small"
                            value={teamsFilter?.resourceType}
                            {...register('resourceType')}
                            onChange={(e) => {
                              setTeamsFilter((prev) => ({
                                ...prev,
                                resourceType: e.target.value
                              }));
                              setValue('resourceType', e.target.value);
                              filterMandatoryFled(e.target.value);
                              setIsDisabledClearBtn(false);
                            }}
                          >
                            <MenuItem value="Billable">Billable</MenuItem>
                            <MenuItem value="Non-Billable">Non-Billable</MenuItem>
                            <MenuItem value="Shadow">Shadow</MenuItem>
                            <MenuItem value="Support">Support</MenuItem>
                            <MenuItem value="T&M">T&M</MenuItem>
                          </Select>
                        </FormControl>
                      </Grid>
                      <Grid item xs={3}>
                        <FormControl fullWidth>
                          <InputLabel
                            style={{
                              fontSize: '12px'
                            }}
                          >
                            Role Type
                          </InputLabel>
                          <Select
                            id="filter-roleType"
                            className="select-text"
                            style={{
                              fontSize: '12px',
                              height: '2rem'
                            }}
                            sx={{ mt: 1 }}
                            fullWidth
                            size="small"
                            value={teamsFilter?.roleType}
                            {...register('roleType')}
                            onChange={(e) => {
                              setTeamsFilter((prev) => ({
                                ...prev,
                                roleType: e.target.value
                              }));
                              setValue('roleType', e.target.value);
                              filterMandatoryFled(e.target.value);
                              setIsDisabledClearBtn(false);
                            }}
                          >
                            <MenuItem value={`Planned`}>Planned</MenuItem>
                            <MenuItem value={`Unplanned`}>Unplanned</MenuItem>
                          </Select>
                        </FormControl>
                      </Grid>
                      <Grid item xs={3}>
                        <FormControl fullWidth>
                          <InputLabel style={{ fontSize: '12px' }}>
                            Track Code
                          </InputLabel>
                          <Select
                            id="filter-trackCode"
                            size="small"
                            displayEmpty
                            inputProps={{ 'aria-label': 'Without label' }}
                            {...register('trackCode')}
                            value={teamsFilter?.trackCode}
                            style={{
                              fontSize: '12px',
                              height: '2rem'
                            }}
                            sx={{ mt: 1 }}
                            onChange={(e) => {
                              setTeamsFilter((prev) => ({
                                ...prev,
                                trackCode: e.target.value
                              }));
                              setValue('trackCode', e.target.value);
                              setIsDisabledClearBtn(false);
                              setIsDisable(false);
                            }}
                          >
                            {(tracks || []).map((item, i) => {
                              return (
                                <MenuItem value={item.code} key={i}>
                                  {item.code}
                                </MenuItem>
                              );
                            })}
                          </Select>
                        </FormControl>
                      </Grid>
                      <Grid item xs={3}>
                        <Typography
                          style={{ fontSize: '13px' }}
                          color="GrayText"
                        >
                          From
                        </Typography>
                        <FormControl fullWidth>
                          <DatePicker
                            InputProps={{
                              className: 'date-picker'
                            }}
                            renderInput={(params) => (
                              <TextField {...params} id="filter-startDate" />
                            )}
                            value={
                              teamsFilter?.startDate
                                ? teamsFilter.startDate
                                : ''
                            }
                            onChange={(newValue) => {
                              if (newValue) {
                                setIsDisabledClearBtn(false);
                                setStartDateError('');
                                setTeamsFilter((prev) => ({
                                  ...prev,
                                  startDate:
                                    moment(newValue).format('YYYY-MM-DD')
                                }));
                                setTeamsFilter((prev) => ({
                                  ...prev,
                                  endDate: ''
                                }));
                                setEndDateError('To date is mandatory field');
                                setIsDisable(true);
                              }
                            }}
                          />
                          {startError && (
                            <Typography
                              style={{
                                paddingLeft: 0,
                                paddingRight: 15,
                                fontSize: '11px',
                                textTransform: 'capitalize',
                                marginTop: 8
                              }}
                              color="red"
                            >
                              {startError}
                            </Typography>
                          )}
                        </FormControl>
                      </Grid>
                      <Grid item xs={3}>
                        <Typography
                          style={{ fontSize: '13px' }}
                          color="GrayText"
                        >
                          To
                        </Typography>
                        <FormControl fullWidth>
                          <DatePicker
                            disabled={!teamsFilter.startDate}
                            InputProps={{
                              className: 'date-picker'
                            }}
                            minDate={new Date(teamsFilter.startDate)}
                            renderInput={(params) => (
                              <TextField {...params} id="filter-endDate" />
                            )}
                            value={
                              teamsFilter?.endDate ? teamsFilter.endDate : ''
                            }
                            onChange={(newValue) => {
                              if (newValue) {
                                setEndDateError('');
                                setTeamsFilter((prev) => ({
                                  ...prev,
                                  endDate:
                                    moment(newValue).format('YYYY-MM-DD')
                                }));
                                setIsDisabledClearBtn(false);

                                if (!teamsFilter.startDate) {
                                  setStartDateError(
                                    'From date is mandatory field'
                                  );
                                  setIsDisable(true);
                                } else {
                                  setIsDisable(false);
                                }
                              }
                            }}
                          />
                          {endDateError && (
                            <Typography
                              style={{
                                paddingLeft: 0,
                                paddingRight: 15,
                                fontSize: '11px',
                                textTransform: 'capitalize',
                                marginTop: 8
                              }}
                              color="red"
                            >
                              {endDateError}
                            </Typography>
                          )}
                        </FormControl>
                      </Grid>
                    </Grid>
                    <Grid
                      container
                      style={{
                        justifyContent: 'flex-end',
                        marginTop: 4,
                        marginBottom: '1.5rem'
                      }}
                      xs={12}
                    >
                      <Button
                        id="btn-resetFilterResult"
                        sx={{ mt: { xs: 2, md: 0 }, mr: 1 }}
                        variant="outlined"
                        onClick={resetFilterResult}
                        disabled={isDisabledClearBtn}
                        className={isDisabledClearBtn &&'clear-btn'}
                        style={{ height: '1.75rem', fontSize: '12px' }}
                      >
                        Clear
                      </Button>
                      <Button
                        id="btn-onSubmit"
                        sx={{ mt: { xs: 2, md: 0 } }}
                        disabled={isDisabled}
                        className={isDisabled &&'filter-btn'}
                        variant="outlined"
                        type="submit"
                        style={{ height: '1.75rem', fontSize: '12px' }}
                      >
                        Filter
                      </Button>
                    </Grid>
                  </form>
                </Grid>
                )}
              {/* </>
            }
            title=""
          /> */}
          <TableContainer >
            <Table style={{ borderCollapse: 'separate' }} size="small">
              <TableHead sx={{ backgroundColor: '#e6e9ff' }}>
                <CustomTableRow sx={{ py: 10 }}>
                  {isEdit && (<TableHeaderCell content="" smallFont />)}
                  <TableHeaderCell content="Resource Name" 
                    smallFont 
                    sort 
                    setSortType={setSortResourceNameType}
                    sortType={sortResourceNameType} />
                  <TableHeaderCell content="Resource Type" smallFont />
                  <TableHeaderCell content="Resource Allocation(%)" smallFont />
                  <TableHeaderCell content="Allocation Start Date" smallFont />
                  <TableHeaderCell content="Allocation End Date" smallFont />
                  <TableHeaderCell content="Project Role" smallFont />
                  <TableHeaderCell content="Start Date" smallFont />
                  <TableHeaderCell content="End Date" smallFont />
                  <TableHeaderCell content="Allocation (%)" smallFont />
                  <TableHeaderCell content="Role Type" smallFont />
                  <TableHeaderCell content="Track Code" smallFont />
                  <TableHeaderCell content="Required Skills" smallFont />{' '}
                  <TableHeaderCell
                    content=" "
                    smallFont
                    rightOffset="80px"
                    width="56px"
                  />
                  <TableHeaderCell
                    content="Actions"
                    smallFont
                    pinRight
                    width="80px"
                  />
                </CustomTableRow>
              </TableHead>
              <TableBody>
                {paginatedTeams?.length > 0 &&
                  paginatedTeams.map((team, i) => {
                    const allocations = team?.resourceAllocations || [];
                    const isTeamExpanded = expandedCodes.includes(team.code);
                    const visibleAllocations =
                      allocations.length > 1 && !isTeamExpanded
                        ? allocations.slice(0, 1)
                        : allocations;
                    const lineCount = Math.max(visibleAllocations.length, 1);
                    const showResourceActions =
                      isEdit &&
                      allocations.length > 0 &&
                      (allocations.length === 1 || isTeamExpanded);
                    const resourceValue = (
                      index: number,
                      value: React.ReactNode
                    ) =>
                      visibleAllocations[index]
                        ? value
                        : index === 0
                        ? 'N/A'
                        : '';

                    return (
                    <TableRow key={team?.code || i}>
                      {isEdit && (
                        <TableColumnCell alignTop>
                          <TeamLines
                            expanded={isTeamExpanded}
                            count={lineCount}
                            renderContent={(index) =>
                              index === 0 ? (
                          <Checkbox
                            id={'checkbox-isChecked' + i}
                            checked={checkedRoles.includes(team.code)}
                            color="primary"
                            onChange={(e) => {
                              if (e.target.checked) {
                                setCheckedRoles([...checkedRoles, team.code]);
                                setIsChecked(true);
                              } else {
                                setCheckedRoles(
                                  checkedRoles.filter(
                                    (fil) => fil !== team.code
                                  )
                                );
                                if (checkedRoles.length === 1) {
                                  setIsChecked(false);
                                }
                              }
                            }}
                                  size="small"
                                  sx={{ padding: '4px' }}
                                />
                              ) : null
                            }
                          />
                        </TableColumnCell>
                      )}
                      <TableColumnCell alignTop>
                        <TeamLines
                          expanded={isTeamExpanded}
                          count={lineCount}
                          renderContent={(index) =>
                            resourceValue(index, visibleAllocations[index]?.name)
                          }
                        />
                      </TableColumnCell>
                      <TableColumnCell alignTop>
                        <TeamLines
                          expanded={isTeamExpanded}
                          count={lineCount}
                          renderContent={(index) =>
                            resourceValue(index, visibleAllocations[index]?.type)
                          }
                        />
                      </TableColumnCell>
                      <TableColumnCell alignTop>
                        <TeamLines
                          expanded={isTeamExpanded}
                          count={lineCount}
                          renderContent={(index) =>
                            resourceValue(
                              index,
                              visibleAllocations[index]
                                ? `${visibleAllocations[index].allocation}%`
                                : ''
                            )
                          }
                        />
                      </TableColumnCell>
                      <TableColumnCell alignTop>
                        <TeamLines
                          expanded={isTeamExpanded}
                          count={lineCount}
                          renderContent={(index) =>
                            resourceValue(
                              index,
                              visibleAllocations[index]?.startDate
                                ? moment(visibleAllocations[index].startDate).format(
                                    'MM/DD/YYYY'
                                  )
                                : ''
                            )
                          }
                        />
                      </TableColumnCell>
                      <TableColumnCell alignTop>
                        <TeamLines
                          expanded={isTeamExpanded}
                          count={lineCount}
                          renderContent={(index) =>
                            resourceValue(
                              index,
                              visibleAllocations[index]?.endDate
                                ? moment(visibleAllocations[index].endDate).format(
                                    'MM/DD/YYYY'
                                  )
                                : ''
                            )
                          }
                        />
                      </TableColumnCell>
                      <TableColumnCell alignTop>
                        <TeamLines
                          expanded={isTeamExpanded}
                          count={lineCount}
                          renderContent={(index) => (index === 0 ? team?.role : '')}
                        />
                      </TableColumnCell>
                      <TableColumnCell alignTop>
                        <TeamLines
                          expanded={isTeamExpanded}
                          count={lineCount}
                          renderContent={(index) =>
                            index === 0
                              ? moment(team?.startDate).format('MM/DD/YYYY')
                              : ''
                          }
                        />
                      </TableColumnCell>
                      <TableColumnCell alignTop>
                        <TeamLines
                          expanded={isTeamExpanded}
                          count={lineCount}
                          renderContent={(index) =>
                            index === 0
                              ? moment(team?.endDate).format('MM/DD/YYYY')
                              : ''
                          }
                        />
                      </TableColumnCell>
                      <TableColumnCell alignTop>
                        <TeamLines
                          expanded={isTeamExpanded}
                          count={lineCount}
                          renderContent={(index) =>
                            index === 0 ? `${team?.allocation}%` : ''
                          }
                        />
                      </TableColumnCell>
                      <TableColumnCell alignTop>
                        <TeamLines
                          expanded={isTeamExpanded}
                          count={lineCount}
                          renderContent={(index) => (index === 0 ? team?.type : '')}
                        />
                      </TableColumnCell>
                      <TableColumnCell alignTop>
                        <TeamLines
                          expanded={isTeamExpanded}
                          count={lineCount}
                          renderContent={(index) =>
                            index === 0 ? team?.trackCode : ''
                          }
                        />
                      </TableColumnCell>
                      <TableColumnCell alignTop>
                        <TeamLines
                          expanded={isTeamExpanded}
                          count={lineCount}
                          renderContent={(index) =>
                            index === 0
                              ? team?.skills?.map((skill, skillIndex) =>
                                  skillIndex === team.skills.length - 1
                                    ? skill
                                    : `${skill},`
                                )
                              : ''
                          }
                        />
                      </TableColumnCell>
                      <TableColumnCell
                        alignTop
                        borderBottom
                        rightOffset="80px"
                        width="56px"
                      >
                        <TeamLines
                          expanded={isTeamExpanded}
                          count={lineCount}
                          lineStyle={{ padding: '0 8px' }}
                          renderContent={(index) => {
                            if (!showResourceActions) return null;
                            const res = visibleAllocations[index];
                            if (!res) return null;
                            const locked = isAllocationLocked(res);
                            const iconStyle = (disabled: boolean) => ({
                              fontSize: '15px',
                              cursor: disabled ? 'not-allowed' : 'pointer',
                              color: disabled ? '#bdbdbd' : 'inherit',
                              marginRight: '4px'
                            });
                            return (
                              <span
                                style={{
                                  display: 'flex',
                                  alignItems: 'center'
                                }}
                              >
                                <Tooltip title="Edit" placement="top">
                                  <span>
                                    <EditIcon
                                      id={`btn-toggleUpdate-${i}-${index}`}
                                      onClick={() => {
                                        setUpdateData({
                                          ...team,
                                          selectedResourceIndex: index
                                        });
                                        toggleUpdate();
                                      }}
                                      style={iconStyle(false)}
                                    />
                                  </span>
                                </Tooltip>
                                <Tooltip
                                  title={
                                    locked
                                      ? 'Locked - allocations older than 2 months cannot be deallocated'
                                      : 'Deallocate'
                                  }
                                  placement="top"
                                >
                                  <span>
                                    <DeleteForeverIcon
                                      id={`btn-toggleDeleteAllocation-${i}-${index}`}
                                      onClick={() => {
                                        if (locked) return;
                                        setDeleteAllocationId(res?.id);
                                        toggleConfirmationDeleteAllocation();
                                      }}
                                      style={iconStyle(locked)}
                                    />
                                  </span>
                                </Tooltip>
                              </span>
                            );
                          }}
                        />
                      </TableColumnCell>
                      {/*<TableColumnCell>
                        {team?.resourceAllocations?.length > 0 &&
                          team.resourceAllocations.map(
                            (res, index) =>
                              index === 0 && (
                                <Typography
                                  paddingBottom="0.25rem"
                                  paddingTop="0.5rem"
                                  style={{ fontSize: '11px' }}
                                  variant="body2"
                                  gutterBottom
                                  noWrap
                                >
                                  {res?.status}
                                </Typography>
                              )
                          )}
                        {team?.resourceAllocations?.length > 0 &&
                          team.resourceAllocations.map(
                            (res, index) =>
                              expand &&
                              expandedCode === team.code &&
                              index !== 0 && (
                                <Typography
                                  paddingBottom="0.25rem"
                                  paddingTop="0.5rem"
                                  style={{ fontSize: '11px' }}
                                  variant="body2"
                                  gutterBottom
                                  noWrap
                                >
                                  {res?.status}
                                </Typography>
                              )
                          )}
                      </TableColumnCell>*/}
                      <TableColumnCell pinRight alignTop borderBottom width="80px">
                        <TeamLines
                          expanded={isTeamExpanded}
                          count={lineCount}
                          lineStyle={{ padding: 0 }}
                          renderContent={(index) =>
                            index === 0 ? (
                        <div
                          style={{
                            display: 'flex',
                            justifyContent: 'flex-end',
                            alignItems: 'center',
                            gap: '6px',
                            boxSizing: 'border-box',
                            paddingRight: '10px',
                            width: '100%'
                          }}
                        >
                          {isEdit && (
                            <Tooltip title="Delete" placement="top">
                              <DeleteForeverIcon
                                id={'btn-toggleConfirmationDelete' + i}
                                onClick={() => {
                                  setDeleteRoleId(team?.code);
                                  toggleConfirmationDelete();
                                }}
                                style={{
                                  fontSize: '15px',
                                  cursor: 'pointer'
                                }}
                              />
                            </Tooltip>
                          )}
                          {team?.resourceAllocations?.length > 1 &&
                            (expandedCodes.includes(team.code) ? (
                              <ExpandLessIcon
                                id={'btn-expandLess' + i}
                                onClick={() => dropDown(team.code)}
                                style={{
                                  fontSize: '15px',
                                  cursor: 'pointer'
                                }}
                              />
                            ) : (
                              <ExpandMoreIcon
                                id={'btn-expandMore' + i}
                                onClick={() => dropDown(team.code)}
                                style={{
                                  fontSize: '15px',
                                  cursor: 'pointer'
                                }}
                              />
                            ))}
                        </div>
                            ) : null
                          }
                        />
                      </TableColumnCell>
                    </TableRow>
                    );
                  })}
              </TableBody>
            </Table>
          </TableContainer>
          {paginatedTeams?.length === 0 && (
            <Typography
              style={{
                fontSize: '15px',
                fontWeight: 'bold',
                margin: '1rem',
                textAlign: 'center'
              }}
              variant="body2"
            >
              No Records Found
            </Typography>
          )}
          <Box p={2}>
            <TablePagination
              sx={{
                fontSize: '12px',
                '.MuiTablePagination-displayedRows': {
                  fontSize: '12px'
                },
                '.MuiTablePagination-selectLabel': {
                  fontSize: '12px'
                }
              }}
              component="div"
              count={filteredTeams.length}
              onPageChange={handlePageChange}
              onRowsPerPageChange={handleLimitChange}
              page={page}
              rowsPerPage={limit}
              rowsPerPageOptions={[10, 20, 30, 40, 50]}
            />
          </Box>
        </Card>
      </Container>
      <AllocateResourcesModal
        open={open}
        toggle={toggle}
        getData={() => getTeamsData(projectDetails?.key)}
        data={checkedRolesData}
        allEmployees={allEmployees}
        setSnackBarOpen={setSnackBarOpen}
        setSnackbarSeverity={setSnackbarSeverity}
        setSnackBarMessage={setSnackBarMessage}
        projectDetails={projectDetails}
      />
      <UpdateModal
        open={openUpdate}
        toggle={toggleUpdate}
        getData={() => filterTeamMembers()}
        data={updateData}
        billingRoles={billingRoles}
        tracks={tracks}
        allSkills={allSkills}
        allEmployees={allEmployees}
        projectCode={projectDetails?.key}
        projectDetails={projectDetails}
        setSnackBarOpen={setSnackBarOpen}
        setSnackbarSeverity={setSnackbarSeverity}
        setSnackBarMessage={setSnackBarMessage}
      />
      <CreateForm 
        open={isOpenAdded}
        toggle={toggleAdded}
        getData={() => getTeamsData(projectDetails?.key)}
        teams={teams}
        projectCode={projectCode}
        projectDetails={projectDetails}
        setSnackBarOpen={setSnackBarOpen}
        setSnackbarSeverity={setSnackbarSeverity}
        setSnackBarMessage={setSnackBarMessage}
      />
      <SnackBar
        snackBarOpen={snackBarOpen}
        setSnackBarOpen={setSnackBarOpen}
        snackBarMessage={snackBarMessage}
        snackbarSeverity={snackbarSeverity}
      />
      <ConfirmationModal
        isLoading={isLoading}
        open={openConfirmationDelete}
        toggle={toggleConfirmationDelete}
        message={`Are you sure you want to delete this role?`}
        onConfirm={() => deleteRole(deleteRoleId)}
        noToggle={toggleConfirmationDelete}
      />
      <ConfirmationModal
        isLoading={isLoading}
        open={openConfirmationDeleteAllocation}
        toggle={toggleConfirmationDeleteAllocation}
        message={`Are you sure you want to delete this resource allocation?`}
        onConfirm={() => deleteAllocation(deleteAllocationId)}
        noToggle={toggleConfirmationDeleteAllocation}
      />
    </Fragment>
  );
};

export default TeamsTable;
